import React from 'react';
import { createPortal } from 'react-dom';
import { Z } from '../../theme';

/** Escape the gameplay HUD's stacking context without promoting the whole HUD. */
export const NPCWindowLayer: React.FC<React.PropsWithChildren> = ({ children }) => {
  if (typeof document === 'undefined') return null;
  return createPortal(
    <div
      data-testid="npc-window-layer"
      style={{
        position: 'fixed', inset: 0, pointerEvents: 'none',
        display: 'flex', flexDirection: 'column', zIndex: Z.npcWindow,
      }}
    >
      {children}
    </div>,
    // Stay inside the application's root layer, below its tooltips and modals.
    document.getElementById('root') ?? document.body,
  );
};
